import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/api";

const name = "getExams";
const initialState = createInitialState();

function createInitialState() {
  return {
    done: false,
    error: false,
    spinner: false,
    getExams: null,
  };
}

export const getExams = createAsyncThunk(
  "getExams",
  async (rejectWithValue) => {
    try {
      const response = await api.get("/api/target-exam/get");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'An error occurred');
    }
  }
);



const getExamsSlice = createSlice({
  name: name,
  initialState,
  reducers: {
    resetGetExams: (state) => {
      state.done = false;
      state.error = false;
      state.spinner = false;
      state.getExams = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getExams.pending, (state) => {
        state.spinner = true;
        state.error = false;
      })
      .addCase(getExams.fulfilled, (state, action) => {
        state.done = true;
        state.spinner = false;
        state.error = false;
        state.getExams = action.payload;
      })
      .addCase(getExams.rejected, (state, action) => {
        state.done = false;
        state.spinner = false;
        state.error = action.payload;
      });
  },
});

export const { resetGetExams } = getExamsSlice.actions;
export const getExamsReducer = getExamsSlice.reducer;
